import * as MutationTypes from './mutationTypes';

const eventListSuccess = (state, payload) => {
  state.eventList = payload;
};

const createEventSuccess = (state, payload) => {
  state.createEventSuccess = payload;
};

const updateEventSuccess = (state, payload) => {
  state.updateEventSuccess = payload;
};

const deleteEventSuccess = (state, payload) => {
  state.deleteEventSuccess = payload;
};

const eventTypeListSuccess = (state, payload) => {
  state.eventTypeList = payload;
};

const createEventTypeSuccess = (state, payload) => {
  state.createEventTypeSuccess = payload;
};

const updateEventTypeSuccess = (state, payload) => {
  state.updateEventTypeSuccess = payload;
};

const deleteEventTypeSuccess = (state, payload) => {
  state.deleteEventTypeSuccess = payload;
};

const eventOccurrenceCalendarListUpdate = (state, { eventOccurrenceList, count }) => {
  state.eventOccurrenceCalendarProgress += (eventOccurrenceList.length / count) * 100;
  state.eventOccurrenceCalendarList.push(...eventOccurrenceList);
};

const eventOccurrenceCalendarListToken = (state, payload) => {
  state.eventOccurrenceCalendarListCancelToken = payload;
};

const clearToken = (state) => {
  state.eventOccurrenceCalendarListCancelToken = null;
};

const resetEventOccurrenceCalendarList = (state) => {
  state.eventOccurrenceCalendarList = [];
  state.eventOccurrenceCalendarProgress = 0;
};

export const mutations = {
  [MutationTypes.EVENT_LIST_SUCCESS]: eventListSuccess,
  [MutationTypes.CREATE_EVENT_SUCCESS]: createEventSuccess,
  [MutationTypes.UPDATE_EVENT_SUCCESS]: updateEventSuccess,
  [MutationTypes.DELETE_EVENT_SUCCESS]: deleteEventSuccess,
  [MutationTypes.EVENT_TYPE_LIST_SUCCESS]: eventTypeListSuccess,
  [MutationTypes.CREATE_EVENT_TYPE_SUCCESS]: createEventTypeSuccess,
  [MutationTypes.UPDATE_EVENT_TYPE_SUCCESS]: updateEventTypeSuccess,
  [MutationTypes.DELETE_EVENT_TYPE_SUCCESS]: deleteEventTypeSuccess,
  [MutationTypes.EVENT_OCCURRENCE_CALENDAR_LIST_UPDATE]: eventOccurrenceCalendarListUpdate,
  [MutationTypes.EVENT_OCCURRENCE_CALENDAR_LIST_TOKEN]: eventOccurrenceCalendarListToken,
  [MutationTypes.EVENT_OCCURRENCE_CALENDAR_LIST_SUCCESS]: clearToken,
  [MutationTypes.EVENT_OCCURRENCE_CALENDAR_LIST_ERROR]: clearToken,
  [MutationTypes.EVENT_OCCURRENCE_CALENDAR_LIST_RESET]: resetEventOccurrenceCalendarList,
};
